/** Stable public entry point reserved for onboarding and installation guidance. */
export const PUBLIC_INSTALL_PATH = '/install';

/**
 * Canonical public doorway encoded by the reusable onboarding QR asset. The
 * .download host redirects to the Pages-hosted PWA and never owns app data.
 */
export const PUBLIC_INSTALL_URL = 'https://conscious-ritual.download/install';

export const PWA_ORIGIN = 'https://conscious-ritual.pages.dev';
export const PWA_INSTALL_REDIRECT_TARGET = `${PWA_ORIGIN}${PUBLIC_INSTALL_PATH}`;
